import { type IndustryCodeDto, industryCodeDtoMap } from "app/pages/sales-intelligence/domain/industry/types/codes";
import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import type { IndustryCodes } from "app/pages/sales-intelligence/types";

import { IndustryCodesFilterValue } from "../../../../models/IndustryCodesFilter/IndustryCodesFilterValue";

export const MAX_INDUSTRY_BULK_VALUES = 500;

export function parseIndustryBulkValue(value: string): string[] {
    return value
        .trim()
        .split(/\s|\s?[,|]\s?/)
        .filter(Boolean);
}

export const limitIndustryBulkParsedCodes = (value: string): string[] =>
    parseIndustryBulkValue(value).slice(0, MAX_INDUSTRY_BULK_VALUES);

export const mergeIndustryBulkCodes = ({
    item,
    bulkRawValue,
    codeType,
    naicsCodes,
    sicCodes,
    excludedCodes = [],
}: {
    item: IIndustryCodesFilterDto;
    bulkRawValue: string;
    codeType: IndustryCodeDto;
    naicsCodes: readonly IndustryCodes[];
    sicCodes: readonly IndustryCodes[];
    excludedCodes?: readonly string[];
}): IIndustryCodesFilterDto => {
    const validCodesSet = new Set(
        (codeType === industryCodeDtoMap.naics ? naicsCodes : sicCodes).map(({ code }) => code),
    );
    const excludedCodesSet = new Set(excludedCodes);

    const parsedCodes = limitIndustryBulkParsedCodes(bulkRawValue).filter(
        (code) => validCodesSet.has(code) && !excludedCodesSet.has(code),
    );

    if (parsedCodes.length === 0) {
        return item;
    }

    const filterValue = new IndustryCodesFilterValue(item);
    const existingCodes = codeType === industryCodeDtoMap.naics ? filterValue.naicsCodes : filterValue.sicCodes;

    return filterValue.with({
        inclusion: item.inclusion,
        [codeType]: Array.from(new Set([...existingCodes, ...parsedCodes])),
    });
};
